import { j as t } from "../../_virtual/jsx-runtime.js";
const l = ({
  width: n = 20,
  height: o = 20,
  viewBox: r = "0 0 20 20",
  fill: s = "currentColor",
  ...e
}) => /* @__PURE__ */ t.jsx(
  "svg",
  {
    width: n,
    height: o,
    viewBox: r,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: /* @__PURE__ */ t.jsx(
      "path",
      {
        d: "M15.8333 3.33333H4.16667V16.6667H15.8333V3.33333ZM2.5 2.49316C2.5 2.03671 2.87291 1.66666 3.33208 1.66666H16.6664C17.1266 1.66666 17.4997 2.03976 17.4998 2.5L17.5 17.4937C17.5 17.9574 17.1292 18.3333 16.6722 18.3333H3.32783C2.87063 18.3333 2.5 17.9539 2.5 17.5068V2.49316ZM9.41075 10.9344L12.9462 7.3989L14.1247 8.57741L9.41075 13.2914L6.16984 10.0506L7.34835 8.872L9.41075 10.9344Z",
        fill: s
      }
    )
  }
);
export {
  l as default
};
